import axios from "axios";
import {jwtDecode} from "jwt-decode";

import {baseURL} from "../configs/urls";

const axiosService = axios.create({baseURL});

// Whether the stored access token is expired (or missing / unparseable).
// Used to decide if a 401 warrants a full logout — see the response interceptor.
const isAccessTokenExpired = (rawTokens) => {
    try {
        const {access} = JSON.parse(rawTokens);
        if (!access) return true;
        const {exp} = jwtDecode(access);
        // No exp claim → can't trust it; treat as expired. Otherwise compare to
        // now (exp is in seconds). A small skew allowance isn't needed here.
        return !exp || Date.now() >= exp * 1000;
    } catch (e) {
        return true;
    }
};

axiosService.interceptors.request.use(
    config => {
        const tokens = localStorage.getItem("token");

        if (tokens) {
            const parsedTokens = JSON.parse(tokens);

            if (parsedTokens?.access) {
                config.headers["Authorization"] = `JWT ${parsedTokens.access}`;
            }
        }
        return config;
    },
    (error) => {
        console.error(error);
    }
);


axiosService.interceptors.response.use(
    response => {
        return response;
    },
    (error) => {
        console.error(error);
        if (error?.response?.status === 401) {
            const tokens = localStorage.getItem("token");

            if (tokens && isAccessTokenExpired(tokens)) {
                // Only force a logout when OUR access token is genuinely
                // expired / unparseable. A stateless SimpleJWT access token is
                // never rejected by the server while still valid, so a 401 with
                // a live token means a *specific* request was rejected (e.g. a
                // gated sub-request, or one that briefly raced before the header
                // was attached) — NOT that the session died. Nuking the whole
                // session on every 401 is what bounced a re-verified/deactivated
                // cleaner straight back to the login page.
                localStorage.clear();
                window.location.reload();
            }
        }

        return Promise.reject(error);
    }
);

export {
    axiosService,
}
